import { render, staticRenderFns } from "./TickerAdminAddService.vue?vue&type=template&id=62a786e0"
import script from "./TickerAdminAddService.vue?vue&type=script&lang=js"
export * from "./TickerAdminAddService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports